import { NgModule} from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

import { extract } from '../core/i18n.service';
import { HomeComponent } from './home.component';
import { DetailsSummaryItineraryComponent } from '../details-summary-itinerary/details-summary-itinerary.component';
// import { TransactionComponent } from '../transaction/transaction.component';
// import { PaymentsComponent } from '../payments/payments.component';
// import { DepositWarrantyComponent } from '../deposits-warranty/deposits-warranty.component';
// import { FidelityComponent } from '../fidelity/fidelity.component';
import { Observable, Subject } from 'rxjs';
import { setting } from '../../../setting';
import { RedirectGuard } from 'app/details-summary-itinerary/RedirectGuard';
import { AuthorizatedGuard } from 'app/pages/com.usblick.common/guard/authorizated.guard';

import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions, selectRoles } from 'app/core/profiles/profiles.selectors';
import { take, takeUntil } from 'rxjs/operators';
import { EventRateMannagerComponent } from './event-rate-mannager/event-rate-mannager.component';


  const routes: Routes = [

  { path: 'home', component: HomeComponent, data: { title: extract('Home') } },
  { path: 'details-summary-itinerary', component: DetailsSummaryItineraryComponent, canActivate: [RedirectGuard] },
  {
    path: 'article',
    loadChildren: () => import('./article/article.module').then(m => m.ArticleModule)
  },
  {
    path: 'shortCutsMannager/:mannagementOption',
    component: EventRateMannagerComponent
  },
  {
    path: 'mannagement',
    loadChildren: () =>
      import('../core/shell/header/profile-mannagement/profile-mannagement.module')
        .then(m => m.ProfileMannagementModule),
    canLoad: [AuthorizatedGuard],
    canActivate: [AuthorizatedGuard]
  },
  {
    // Cotización offline: antes se abría como modal desde el header,
    // ahora es una vista independiente.
    path: 'offline-quote',
    loadChildren: () =>
      import('../offline-quote/offline-quote.module').then(m => m.OfflineQuoteModule),
    canLoad: [AuthorizatedGuard],
    canActivate: [AuthorizatedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class HomeRoutingModule {
  public apiBookingUrl: string;

  public moduleProfile: any;

  roles$: Observable<string[]>;
  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

    private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
              private router: Router,
              private store: Store<AppState>) {
    this.apiBookingUrl = setting.apiBookingUrl;
    this.roles$ = this.store.select(selectRoles);
    this.permissions$ = this.store.select(selectPermissions);

    this.permissions$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
      this.hasAccess(this.permissionsMap);
    });

  }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      // Utiliza el nombre del permiso como clave
      map[permission.name] = permission;
    });
    return map;
  }

    hasAccess(permissions: any) {

            //  if(Object.keys(permissions).length > 0) {

            //     if(permissions['booking.pagos.habilitar'] === undefined) {
            //       window.location.href = setting.appUrl;
            //     }

            //     if(permissions['booking.pagos.habilitar']) {
            //        // Para agregar una ruta dinámicamente, puedes usar el método `resetConfig` del Router.
            //       this.router.resetConfig([
            //         ...this.router.config,
            //         {
            //           path: 'payments', // Definir la nueva ruta
            //           component: PaymentsComponent, // El componente que se debe cargar
            //           data: { title: extract('My Payments') } // Datos asociados a la ruta
            //         }
            //       ]);
            //     }
            //     if(permissions['booking.depositoengarantia.habilitar']) {
            //       this.router.resetConfig([
            //         ...this.router.config,
            //         {
            //           path: 'deposits-warranty',
            //           component: DepositWarrantyComponent,
            //           data: { title: extract('My Deposits Warranty') }
            //         }
            //       ])
            //     }
            //     if(permissions['booking.blickoins.habilitar']) {
            //       this.router.resetConfig([
            //         ...this.router.config,
            //         {
            //           path: 'fidelity',
            //           component: FidelityComponent,
            //           data: { title: extract('My Blickoins') }
            //         }
            //       ])
            //     }
            //     if(permissions['booking.limitecredito.habilitar']) {
            //       this.router.resetConfig([
            //         ...this.router.config,
            //         {
            //           path: 'credits-limit',
            //           component: CreditLimitComponent,
            //           data: { title: extract('My Limit Credits') }
            //         }
            //       ])
            //     }
            //     if(permissions['booking.transacciones.habilitar']) {
            //       this.router.resetConfig([
            //         ...this.router.config,
            //         {
            //           path: 'transaction',
            //           component: TransactionComponent,
            //           data: { title: extract('My Tansactions') }
            //         }
            //       ])
            //     }
            //   }
      }

 }
